// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__140Al","title":"AfterFrontImage_title__bYqnB"};